import { useCallback, useMemo } from 'react';

import { RadioOptionsWithConfirm, IQuestion } from 'shared-components';
import { AccommodationArrangedStatusEnum } from 'types';

interface IProps {
  accommodationArrangedStatus: AccommodationArrangedStatusEnum;
  selectedAccommodationArrangedStatus: {
    status: AccommodationArrangedStatusEnum;
    setStatus: (status: AccommodationArrangedStatusEnum) => void;
  };
}

export const HaveYouArrangedAccommodation = ({
  selectedAccommodationArrangedStatus,
  accommodationArrangedStatus
}: IProps) => {
  const { status, setStatus } = selectedAccommodationArrangedStatus;

  accommodationArrangedStatus = accommodationArrangedStatus || AccommodationArrangedStatusEnum.NONE;

  const questions = useMemo(
    () => [
      {
        char: 'Y',
        status: AccommodationArrangedStatusEnum.ARRANGED,
        label: 'Yes',
        selected: status === AccommodationArrangedStatusEnum.ARRANGED
      },
      {
        char: 'N',
        status: AccommodationArrangedStatusEnum.NOT_ARRANGED,
        label: 'No',
        selected: status === AccommodationArrangedStatusEnum.NOT_ARRANGED
      }
    ],
    [status]
  );

  const getArrangedStatusFromLabel = useCallback(
    (label: string) => {
      return questions.find(notHandledQuestion => {
        return notHandledQuestion.label === label;
      })!.status;
    },
    [questions]
  );

  const clickHandler = useCallback(
    (question: IQuestion) => {
      setStatus(getArrangedStatusFromLabel(question.label));
    },
    [getArrangedStatusFromLabel, setStatus]
  );

  return (
    <div data-selector="enrolment-section-accommodation-status-questions">
      <RadioOptionsWithConfirm
        isInline={true}
        label={'Have you arranged your accommodation yet?'}
        questions={questions}
        onClick={clickHandler}
      />
    </div>
  );
};
